module.exports = __webpack_public_path__ + "img/ecowall.72f7ae46.webp";